import React from "react"

export default function Tabla({tabla}) {
  
  return (
    <React.Fragment>
      <table className="tabla_fase">
        <thead data-nivel="1" data-orden="1"><tr>
          <th>Nº</th>
          <th>Equipo</th>
          <th>PTS</th>
          <th className="hidden-xs">PJ</th>
          <th className="hidden-xs">PG</th>
          <th className="hidden-xs">PE</th>
          <th className="hidden-xs">PP</th>
          <th className="hidden-xs">DF</th>
        </tr></thead>
        <tbody>
          {
            tabla.map( (equipo, index) => {
              let rowClassName = `equipo-pos equipo-${equipo.EQUIPO.toLowerCase().trim()} `
              if (index < 4) {
                rowClassName += "clasifica"
              } else if (index === 4) {
                rowClassName += "repechaje"
              } else {
                rowClassName += "fuera"
              }
              return <tr className={rowClassName} key={`${equipo.EQUIPO}${equipo.PUNTOS}${equipo.PJ}`}>
                <td className="pos">{index + 1}</td>
                <td className="team"><img src={equipo.LOGO} alt="" /> &nbsp;&nbsp; {equipo.EQUIPO}</td>
                <td className="text-center"> <div className="valor-puntos" id={`pt-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.PUNTOS}</div></td>
                <td className="text-center"> <div className="valor-pj" id={`pj-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.PJ}</div></td>
                <td className="text-center"> <div className="valor-pg" id={`pg-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.PG}</div></td>
                <td className="text-center"> <div className="valor-pe" id={`pe-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.PE}</div></td>
                <td className="text-center"> <div className="valor-pp" id={`pp-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.PP}</div></td>
                <td className="text-center"> <div className="valor-df" id={`df-${equipo.EQUIPO.toLowerCase().trim()}`}>{equipo.DF}</div></td>
              </tr>
            })
          }
        </tbody></table>
    </React.Fragment>
  )
}